import React, {Fragment, useRef} from "react";
import { Link , NavLink} from "react-router-dom";
import {Skeleton} from "@mui/material";
import LazyLoad from "react-lazy-load";
import {Navigation, Pagination} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
const Home_Section_G = (props) => {
    return (


        <Fragment>


<div className={"home-sec-g-box"}>

    <span className={"home-sec-g-title"}>نظرات مشتریان</span>
    { props.Coments_last && props.Coments_last.length > 0 ? (
        <Fragment>


            <Swiper
                modules={[Pagination]}
                pagination={{clickable: true}}
                lazy={true}
                dir="rtl"
                spaceBetween={25}
                slidesPerView={3}
                loop={true}
                navigation={false}
                draggable={true}
                className="mySwiper slider-component mySwiper-secb"
                centeredSlides={true}
                breakpoints={{
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    800: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    300: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },

                }}
            >


                {


                    props.Coments_last.map((item_post, index) => {


                        return (

                            <SwiperSlide className=" slide-container swiper-home-Coments_last">

                                <div className={"Coments_last_home"}>


                                    <svg width={75} height={75} viewBox="0 0 75 75" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="37.5" cy="37.5" r="37.5" fill="#FF9828"/>
                                        <path
                                            d="M54.4965 51.7774C51.8409 47.1885 47.672 43.9685 42.8277 42.6029C45.1829 41.4057 47.0662 39.4502 48.174 37.0517C49.2818 34.6532 49.5495 31.9515 48.934 29.3822C48.3185 26.8129 46.8556 24.5258 44.7812 22.8897C42.7067 21.2536 40.1418 20.3638 37.4998 20.3638C34.8578 20.3638 32.2928 21.2536 30.2184 22.8897C28.144 24.5258 26.6811 26.8129 26.0655 29.3822C25.45 31.9515 25.7177 34.6532 26.8255 37.0517C27.9333 39.4502 29.8166 41.4057 32.1718 42.6029C27.3276 43.9668 23.1586 47.1868 20.503 51.7774C20.4301 51.8921 20.3811 52.0204 20.3591 52.1545C20.337 52.2886 20.3423 52.4258 20.3746 52.5578C20.407 52.6898 20.4657 52.814 20.5472 52.9227C20.6288 53.0314 20.7315 53.1226 20.8492 53.1906C20.9668 53.2586 21.0971 53.3021 21.232 53.3185C21.3669 53.3349 21.5038 53.3238 21.6343 53.286C21.7649 53.2481 21.8864 53.1842 21.9916 53.0982C22.0968 53.0121 22.1835 52.9056 22.2465 52.7852C25.4732 47.2103 31.1741 43.8829 37.4998 43.8829C43.8255 43.8829 49.5263 47.2103 52.753 52.7852C52.816 52.9056 52.9027 53.0121 53.0079 53.0982C53.1131 53.1842 53.2347 53.2481 53.3652 53.286C53.4958 53.3238 53.6326 53.3349 53.7675 53.3185C53.9025 53.3021 54.0327 53.2586 54.1504 53.1906C54.268 53.1226 54.3708 53.0314 54.4523 52.9227C54.5338 52.814 54.5926 52.6898 54.6249 52.5578C54.6572 52.4258 54.6625 52.2886 54.6405 52.1545C54.6184 52.0204 54.5694 51.8921 54.4965 51.7774ZM27.7576 32.125C27.7576 30.1982 28.3289 28.3147 29.3994 26.7126C30.4699 25.1105 31.9914 23.8618 33.7716 23.1244C35.5517 22.3871 37.5106 22.1942 39.4004 22.5701C41.2902 22.946 43.0261 23.8738 44.3885 25.2363C45.751 26.5988 46.6789 28.3346 47.0548 30.2244C47.4307 32.1142 47.2377 34.0731 46.5004 35.8532C45.763 37.6334 44.5143 39.1549 42.9122 40.2254C41.3101 41.2959 39.4266 41.8672 37.4998 41.8672C34.9169 41.8641 32.4408 40.8367 30.6144 39.0104C28.7881 37.184 27.7607 34.7079 27.7576 32.125Z"
                                            fill="white"/>
                                    </svg>

                                    <span className={"nameuser-Coments_last"}>{item_post.name_avator}</span>




                                    <div className="home-Coments_last-description">{item_post.description}</div>


                                </div>

                            </SwiperSlide>

                        )

                    })

                }


            </Swiper>


        </Fragment>

    ) : (<Fragment></Fragment>)

    }

</div>





        </Fragment>
    );
}

export default Home_Section_G;